import { gql } from "@apollo/client";

export const TheirInfluenceFragment = gql`
  fragment TheirInfluence on Inductee {
    inducteeData {
      includeInfluenceSection
      inducteeInfluence {
        headline
        body
        imageAttribution
        image {
          ...ACFMedia
        }
        influences {
          type
          name
          inductee {
            node {
              ... on Inductee {
                title
                uri
              }
            }
          }
        }
        influenced {
          type
          name
          inductee {
            node {
              ... on Inductee {
                title
                uri
              }
            }
          }
        }
      }
      membersSection {
        headline
        body
      }
    }
  }
`;